<div class="fade-in wrapper">
	@if (pools().length > 0) {
		<app-list
			[enableSelect]="true"
			[items]="pools()"
			[selectedUuid]="selectedUuid()"
			prefix="USER POOL"
			(onSelect)="select($event)"
		>
			<ng-template let-item>
				<div>{{ item.name }}</div>
			</ng-template>
		</app-list>
	}
</div>
